// components
import {  Container  } from "@mui/material";
import TabsContent from "components/UI/TabsContent/TabsContent";
import { HTag } from "components/HTag";
import { InfoAbout } from "components/InfoAbout";
import { InfoBodies } from "components/InfoBodies";
import { InfoHistory } from "components/InfoHistory";
import { TeamList } from "components/TeamList";
import { BreadCrumbs } from "components/BreadCrumbs";
// hooks
import React, {   useState } from "react";
import { useTranslation } from "react-i18next";

import classes from "./about.module.scss";

import "@fancyapps/ui/dist/fancybox/fancybox.css";


const VALUES = {
  souz: "souz",
  history: "history",
  organ: "organ",
  projects: "projects",
  ourTeam: "our-team",
};

const GetComponentByTab = ({ action }) => {

  switch (action) {
    case VALUES.souz: {
      return <InfoAbout />;
    }
    case VALUES.history: {
      return <InfoHistory />;
    }
    case VALUES.organ: {
      return <InfoBodies />;
    }
    case VALUES.ourTeam: {
      return <TeamList />;
    }
    default:
      return <></>;
  }
};

const About = () => {
  const { t } = useTranslation();
  const tabsList = [
    { value: VALUES.souz, label: t("aboutUs") },
    { value: VALUES.history, label: t("historyAboutUs") },
    { value: VALUES.organ, label: t("organAboutUs") },
    { value: VALUES.ourTeam, label: t("ourTeamAboutUs") },
  ];
  const [value, setValue] = useState(tabsList?.[0]?.value);

  return (
    <Container className={classes.aboutContainer}>
      <BreadCrumbs path={t("aboutUnion")} />
      <HTag tag={"h2"}>{t("aboutUnion")}</HTag>
      <TabsContent tabsList={tabsList} value={value} setValue={setValue} />
      <GetComponentByTab action={value} />
    </Container>
  );
};

export default About;
